<template>
    <div>
        <b-modal
            id="file-details-modal"
            :title="file.name"
            ok-title="Update"
            size="md"
            @ok="update">
            <b-form @submit="update">
                <b-form-group label="Layout info" label-for="file-floor">
                    <b-form-input
                        id="file-floor"
                        v-model="floor_name"
                        autofocus
                        placeholder="Enter layout info / identifier..."
                        :state="errors.floor_name === null ? null : false"
                        @input="errors.floor_name = null"/>

                    <b-form-invalid-feedback v-text="errors.floor_name"/>
                </b-form-group>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import axios from "axios";

export default {
    props: {
        file: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            floor_name: this.file.floor_name,

            errors: {
                floor_name: null,
            }
        }
    },
    methods: {
        update() {
            const token = this.$store.state.token;

            axios({
                url: this.$store.getters.apiBase + '/projects/' + this.$route.params.id + '/files/' + this.file.id,
                headers: {"Authorization": "Bearer " + token},
                method: 'PATCH',
                data: {
                    floor_name: this.floor_name
                }
            }).then(response => {
                this.$emit('updated', response.data.data);
                this.$bvModal.hide('file-details-modal');
            }).catch(error => {
                if (error.response?.data?.errors) {
                    this.setErrors(error.response.data.errors);
                }
            });
        },
        setErrors(errors) {
            Object.entries(errors).forEach(([input, errors]) => {
                this.errors[input] = errors[0] ?? null;
            });
        }
    }
}
</script>
